<section class="content">
  <div class="container-fluid">
    <!-- Info boxes -->
    <div class="row">
      <!--<ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden">
        </ngb-datepicker> -->
      <div class="col-1"></div>
      <div class="col-sm-6 col-md-5 row select">
        <div class="col-md-4">
          <div class="info-box-content padding">
            <span class="info-box-text">Select Organization</span>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <ng-select class="selectpicker selecterchart" [(ngModel)]="organization_ref_id"
              (ngModelChange)="onOrgChange($event)" placeholder="Select Organization">
              <ng-option value="">Select Organization</ng-option>
              <ng-option *ngFor="let org of orgList; let i = index" [value]="org.id">{{ org.org_name }}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>



      <div class="col-sm-6 col-md-5 row select margin_left">
        <div class="col-md-3">
          <div class="info-box-content padding">
            <span class="info-box-text">Select Site</span>
          </div>
        </div>
        <div class="col-md-9">
          <div class="form-group">
            <ng-select class="selectpicker selecterchart" [(ngModel)]="plant_ref_id"
              (ngModelChange)="onPlantChange($event)" placeholder="Select Site">
              <ng-option value="">Select Site</ng-option>
              <ng-option *ngFor="let plant of plantList; let i = index" [value]="plant.id">{{ plant.name }}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-6 col-md-3">
        <div class="info-box">
          <span class="info-box-icon bg-ua elevation-1"><i class="fas fa-fire-extinguisher"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Unsafe Act</span>
            <span class="info-box-number">
              {{ (ua)?ua:0 }}
              <small></small>
            </span>
          </div>
        </div>

      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <div class="info-box mb-3">
          <span class="info-box-icon bg-uc elevation-1"><i class="fas fa-dumpster-fire"></i></span>
          <div class="info-box-content">
            <span class="info-box-text">Unsafe Condition</span>
            <span class="info-box-number">{{ (uc)?uc:0 }}</span>
          </div>
        </div>
      </div>



      <div class="clearfix hidden-md-up"></div>

      <div class="col-12 col-sm-6 col-md-3">
        <div class="info-box mb-3">
          <span class="info-box-icon bg-dayspassed elevation-1"><i class="fas fa-calendar-alt"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Days since last Issue</span>
            <span class="info-box-number">{{ dayspassed }}</span>
          </div>
        </div>
      </div>
      <!-- /.col -->
      <div class="col-12 col-sm-6 col-md-3">
        <div class="info-box mb-3">
          <span class="info-box-icon bg-plant elevation-1"><i class="fas fa-users"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Users In Site</span>
            <span class="info-box-number">{{ plantusers }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->
    <div class="row barchart">
      <div class="col-md-6 col-sm-12 boxpadding">
        <div class="row boxshadow">
          <div class="col-md-12 head"> Issues By Status </div>
          <div class="col-md-11">
            <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
              [legend]="barChartLegend" [chartType]="barChartType" [options]="barchartOption">
            </canvas>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 boxpadding">
        <div class="row boxshadow">
          <div class="col-md-12 head"> Issues By Severity </div>
          <div class="col-md-11">
            <canvas baseChart [datasets]="barChartsevData" [labels]="barChartsevLabels" [options]="barChartsevOptions"
              [legend]="barChartsevLegend" [chartType]="barChartsevType" [options]="barchartsevOption">
            </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="col-md-6 col-sm-12 boxpadding" *ngIf="category.length>0">
        <div class="boxshadow">
          <div class="head">By Category</div>
          <div class="col-md-12">
            <div  [ngClass]="{'chartWrapper':pieChartLabels.length<15?'chartWrapper':'chartWrapper2'}">
              <div class="chartAreaWrapper">
            <canvas baseChart [datasets]="pieChartData" [labels]="pieChartLabels" [options]="pieChartOptions"
              [legend]="pieChartLegend" [chartType]="pieChartType">
            </canvas>
          </div>
          </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 boxpadding" *ngIf="area.length>0">
        <div class="boxshadow">
          <div class="head">By Area</div>
          <div class="col-md-12">
            <div [ngClass]="{'chartWrapper':pieChartLabels.length<15?'chartWrapper':'chartWrapper2'}">
              <div class="chartAreaWrapper">
            <canvas baseChart [datasets]="pieChartsevData" [labels]="pieChartsevLabels" [options]="pieChartsevOptions"
              [legend]="pieChartsevLegend" [chartType]="pieChartsevType">
            </canvas>
          </div>
        </div>
        </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 boxpadding" *ngIf="observation2Selected==1 && userType==5">
        <div class="boxshadow">
          <div class="head">By Assigned User</div>
          <div class="row">
            <!-- <div class="col-md-2"></div> -->
            <div class="col-md-12">
              <div class="chartWrapper4">
                <div class="chartAreaWrapper4">
                  <canvas baseChart [datasets]="pieChartAssignData" [labels]="pieChartAssignLabels"
                  [options]="piechartAssignOption" [legend]="pieChartAssignLegend" [chartType]="pieChartAssignType">
                </canvas>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-2"></div> -->
          </div>
        </div>
      </div>
    </div>


    <!-- /.row -->

  </div>
  <!--/. container-fluid -->

</section>
<!-- /.content -->

<!-- /.content-wrapper -->